import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { mssPageMeta, mssSchema } from 'components/common/schema'
import Template from 'components/cases/mss'

const Mss: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...mssPageMeta} />
      <JsonLd data={mssSchema} />
      <Template />
    </>
  )
}

export default Mss
